import React from 'react';

import {Notation} from 'biojs/BioConstants';
import {RegistryLabelingStrategy} from 'constants/RegistryConstants';
import {RegistrationStructuredTableAdapter} from 'notebook/integrations/registry/RegistrationStructuredTableAdapter';
import {RegistrationTableInsertType} from 'notebook/integrations/registry/RegistrationTableConstants';
import SimpleTableEditable, {standaloneProps} from 'notebook/simple-tables/SimpleTableEditable';
import {SchemaAndColumnGroup} from 'notebook/structured-tables/StructuredTableConstants';
import {EMPTY_PLACEHOLDER_INSERTION_CONTEXT} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import FieldLabel from 'ui-library/inputs/FieldLabel';

import {ImplementedStaticSchemaInterfaceGQL} from './RegistrationTableInsertModal';

export interface RegistrationTablePreviewProps {
  schema: SchemaAndColumnGroup;
  adapter: RegistrationStructuredTableAdapter;
  insertType: keyof typeof RegistrationTableInsertType;
  labelingStrategy: RegistryLabelingStrategy;
  cid: string;
  selectorsById: {[selectorId: string]: SchemaFieldSelector} | null;
  implementedSchemaInterfaces: Array<ImplementedStaticSchemaInterfaceGQL>;
  notation?: Notation | null;
  customSyntaxName?: string | null;
}

export function RegistrationTablePreview(props: RegistrationTablePreviewProps): JSX.Element {
  const structuredTable = {
    ...props.adapter.createTable({
      name: props.schema.name,
      schemas: [props.schema],
      entryId: 'etr_123',
      metadata: {
        insertType: RegistrationTableInsertType[props.insertType],
        labelingStrategy: props.labelingStrategy,
        notation: props.notation,
        customSyntaxName: props.customSyntaxName,
        implementedSchemaInterfaces: props.implementedSchemaInterfaces,
      },
      selectorsById: props.selectorsById || {},
      structuredTableInsertionContext: EMPTY_PLACEHOLDER_INSERTION_CONTEXT,
    }),
    cid: props.cid,
  };

  const table = props.adapter.toTable(props.adapter.prepareForPreview(structuredTable));

  return (
    <FormGroup className="u-spacing-top">
      <FieldLabel label="Preview" />
      <div className="modal-mediocre-tableWrapper">
        <SimpleTableEditable
          {...standaloneProps}
          table={table}
          cid={props.cid}
          locked={true}
          hideFormulaBox={true}
          viewer={true}
          icon="register"
          enableFormulas={false}
          hasPlaceholderRows={true}
          storeState={() => {}}
          tableLabel={props.adapter.getDisplayName(structuredTable)}
          isLeftAlignColumnHeader={true}
        />
      </div>
    </FormGroup>
  );
}
